/**
 * UK postcode format, as the e-Bulk specification section 3.7.4 describes it (the DBS checks this as business
 * validation, not in the schema; error code 101).
 *
 * UK postcodes must be in one of the following forms (with one exception, see below):
 *   A9 9AA, A99 9AA, AA9 9AA, AA99 9AA, A9A 9AA, AA9A 9AA
 * where A represents an alphabetic character and 9 represents a numeric character.
 *
 * Additional rules apply to alphabetic characters:
 * - the character in position 1 may not be Q, V or X
 * - the character in position 2 may not be I, J or Z
 * - the character in position 3 may not be I, L, M, N, O, P, Q, R, V, X, Y or Z
 * - the character in position 4 may not be C, D, F, G, I, J, K, L, O, Q, S, T, U or Z
 * - the characters in the rightmost two positions may not be C, I, K, M, O or V
 *
 * The positions are those of the outward code (the part before the space): position 3 is the letter in A9A, position 4
 * the letter in AA9A. Counting through the whole postcode with the space removed would apply them to the inward code,
 * refusing valid postcodes such as B6 5JH (DBS-357).
 *
 * The one exception is "GIR 0AA", a special valid postcode. The value is checked as entered (upper case, one space).
 */
export const isValidPostcode = (postcode?: string | null): boolean => {
  if (postcode == null) return false

  if (postcode === 'GIR 0AA') return true

  const validPostcodeRegexs = [
    /^[A-Z][0-9] [0-9][A-Z][A-Z]$/,
    /^[A-Z][0-9][0-9] [0-9][A-Z][A-Z]$/,
    /^[A-Z][A-Z][0-9] [0-9][A-Z][A-Z]$/,
    /^[A-Z][A-Z][0-9][0-9] [0-9][A-Z][A-Z]$/,
    /^[A-Z][0-9][A-Z] [0-9][A-Z][A-Z]$/,
    /^[A-Z][A-Z][0-9][A-Z] [0-9][A-Z][A-Z]$/,
  ]
  if (!validPostcodeRegexs.some(regex => regex.test(postcode))) return false

  const [outward, inward] = postcode.split(' ')

  if ('QVX'.indexOf(outward[0]) >= 0) return false
  if ('IJZ'.indexOf(outward[1]) >= 0) return false
  if (outward.length > 2 && 'ILMNOPQRVXYZ'.indexOf(outward[2]) >= 0) return false
  if (outward.length > 3 && 'CDFGIJKLOQSTUZ'.indexOf(outward[3]) >= 0) return false

  if ('CIKMOV'.indexOf(inward[1]) >= 0) return false
  if ('CIKMOV'.indexOf(inward[2]) >= 0) return false

  return true
}
